import { Stack } from '../../core/Stack';
import styled from '@emotion/styled';
import { IThemeOptions } from '../../../theming/IThemeOptions';
import { FontGroups } from '../../../theming/fontGroups';
import { useTheme } from '@emotion/react';

export const SignStyle = styled(Stack)<{
  themeOptions: IThemeOptions;
}>`
  width: fit-content;
  font-family: ${(props) => props.themeOptions.typography.get(FontGroups.propertySign)?.font};
  font-size: ${(props) => props.themeOptions.typography.get(FontGroups.propertySign)?.size};
  font-weight: bold;
  background-color: ${(props) => props.themeOptions.palette.propertyStatusOwnedBackground};
  border: ${(props) => props.themeOptions.palette.propertyStatusBorder};
  border-radius: ${(props) => props.themeOptions.palette.propertyStatusRadius};
  white-space: nowrap;
  min-width: auto;
  padding-left: 5px;
  padding-right: 5px;
  margin-top: 0;
`;

export function OwnedSign() {
  const coreTheme = useTheme() as IThemeOptions;
  return <SignStyle themeOptions={coreTheme}>OWNED</SignStyle>;
}
